import { Injectable } from '@angular/core';

import { isTipoComissaoRepresentantePorCliente, isTipoComissaoRepresentantePorItem } from '../../../pessoa/representante/representante-tipo-comissao';
import { TabelaPrecoItem } from '../../../tabela-preco/item';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemComissaoService {

    /** Obtem a comissão para o item do pedido */
    getComissao(tabelaPrecoItem: TabelaPrecoItem,  tipoComissaoRepresentante: number, percComissaoCliente: number, percComissaoRepresentante: number) {
        // Comissão por cliente
        if (isTipoComissaoRepresentantePorCliente(tipoComissaoRepresentante)) {
            // Se o item na tabela de preço possuir uma comissão fixa, então consideramos a comissão do item na tabela de preço
            if (tabelaPrecoItem.percComissao != null && tabelaPrecoItem.percComissao !== undefined) {
                return tabelaPrecoItem.percComissao;
            }

            // Se o item possuir uma comissão fixa, então consideramos essa comissão fixa do item
            if (tabelaPrecoItem.item && (tabelaPrecoItem.item.percComissao != null && tabelaPrecoItem.item.percComissao !== undefined)) {
                return tabelaPrecoItem.item.percComissao;
            }

            // Se o cliente possuir comissão fixa, então consideramos essa comissão fixa do cliente
            if (percComissaoCliente != null && percComissaoCliente !== undefined) {
                return percComissaoCliente;
            }

            // Se não setamos a comissão fixa do representante
            return percComissaoRepresentante;
        }

        // Comissão por item
        if (isTipoComissaoRepresentantePorItem(tipoComissaoRepresentante)) {
            return tabelaPrecoItem.item?.percComissao ?? null;
        }

        return null;
    }
}
